// IMPORTS
import { mapActions } from 'vuex';
import { LOOKUP_MODULE, LOOKUP_COMPANY, LOOKUP_DEPARTMENT, LOOKUP_CANDIDATE_JOB, LOOKUP_LOCATION, LOOKUP_PANEL_TYPE } from '@/state/public/lookup.state';
import { CANDIDATE_JOB_MODULE, GET_ALL_CANDIDATE_JOB, GET_CANDIDATE_JOB } from '@/state/public/candidateJob.state';
import { CANDIDATE_MODULE, CREATE_CANDIDATE, GET_CANDIDATE, UPDATE_CANDIDATE, CREATE_CANDIDATE_USER } from '@/state/public/candidate.state';
import { PANEL_MODULE, GET_ALL_PANEL, GET_PANEL } from '@/state/public/panel.state';
import { USER_MODULE, GET_ALL_USER, GET_USER } from '@/state/public/user.state';

// EXPORTS
export const lookupMethods = mapActions(LOOKUP_MODULE, [LOOKUP_COMPANY, LOOKUP_DEPARTMENT, LOOKUP_CANDIDATE_JOB, LOOKUP_LOCATION, LOOKUP_PANEL_TYPE]);
export const candidateJobMethods = mapActions(CANDIDATE_JOB_MODULE, [GET_ALL_CANDIDATE_JOB, GET_CANDIDATE_JOB]);
export const candidateMethods = mapActions(CANDIDATE_MODULE, [CREATE_CANDIDATE, GET_CANDIDATE, UPDATE_CANDIDATE, CREATE_CANDIDATE_USER]);
export const panelMethods = mapActions(PANEL_MODULE, [GET_ALL_PANEL, GET_PANEL]);
export const userMethods = mapActions(USER_MODULE, [GET_ALL_USER, GET_USER]);
